import React from "react";

import Container from "react-bootstrap/Container";
import { useHistory, useRouteMatch } from "react-router";

import {
  getUserManual as getUserManualApi,
  getTermsOfService as getTermsOfServiceApi,
  getConsent as getConsentApi,
  getInitialConversation as getInitialConversationApi
} from "../../api/kindergartenApi";
import { aboutProgramRoute, newErrorReporRoute } from "../../app";
import { izjavaOPristupacnostiRoute } from "../../app";
import { MatchParams, Sidebar, UserRoleAuthorization } from "../../components";
import { CreateErrorReport } from "../../features";
import AboutProgram from "../../features/AboutProgram/AboutProgram";
import { useAuthorization } from "../../hooks";
import { CustomFooter, FooterItem } from "../CustomFooter";
import { Navbar } from "../Navbar";
import styles from "./Layout.module.scss";
import { Navigation } from "./Navigation";

export interface LayoutProps {
  setImpairedStyle: () => void;
  removeImpairedStyle: () => void;
  children?: React.ReactNode;
}

export const Layout = ({   
  children,
  setImpairedStyle,
  removeImpairedStyle, 
}: LayoutProps) => {
  const newReportErrorMatch = useRouteMatch<MatchParams>(newErrorReporRoute);
  const aboutPageMatch = useRouteMatch<MatchParams>(aboutProgramRoute);
  const isIzjavaOPristupacnostiMatch = useRouteMatch<MatchParams>(izjavaOPristupacnostiRoute);

  const { isAuthorized } = useAuthorization(false);
  const history = useHistory();

  const getContainerComponent = () => {
    if (!isAuthorized) {
      return <UserRoleAuthorization />;
    } 
    else if (newReportErrorMatch) {
      return <CreateErrorReport/>;
    }    
    
    else {
        return <Sidebar showAboutPage={aboutPageMatch ? true : false} showIzjavaOPristupacnostiPage={isIzjavaOPristupacnostiMatch ? true : false} />; 
    }
  };

  const showAboutProgram = () => {
      window.scrollTo(0, 0);
      history.push(aboutProgramRoute);
  };
  const showIzjavaOPristupacnosti = () => {
      window.scrollTo(0, 0);
      history.push(izjavaOPristupacnostiRoute);
  };


  const footerItems: Array<FooterItem> = [
    {
      label: "Uvjeti korištenja",
      callback: (item: FooterItem) => {
        getTermsOfServiceApi();
        return false;
      },
    },    
    {
      label: "Korisničke upute",
      callback: (item: FooterItem) => {
        getUserManualApi();
        return false;
      },
    },
    {
      label: "Privola",
      callback: (item: FooterItem) => {
        getConsentApi();
        return false;
      },
    },
    {
      label: "Inicijalni upitnik",
      callback: (item: FooterItem) => {
        getInitialConversationApi();
        return false;
      },
    },
    {
      label: "O programu",
      callback: (item: FooterItem) => {
        showAboutProgram();
        return false;
      },
    },
    {
      label: "Izjava o pristupačnosti",
      callback: (item: FooterItem) => {
          showIzjavaOPristupacnosti();
          return false;
      },
    },
  ];

  return (
    <>
      <Navbar
        setImpairedStyle={setImpairedStyle}
        removeImpairedStyle={removeImpairedStyle}
      />
      <Navigation />
      <main className={styles.main}>
        <Container className={styles.container}>
          {getContainerComponent()}
          {children}
        </Container>
      </main>
      <CustomFooter
        items={footerItems}
      />
    </>
  );
};
